// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"833":"6ed4e551","881":"3d853097"}[chunkId] + ".chunk.css";
};